import { Component } from "./component.js";

class ProductSupportTabs extends Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.navItems = this.querySelectorAll(".product-support__nav-item");
    this.tabPanels = this.querySelectorAll(".product-support__tab-panel");
    this.productItems = this.querySelectorAll(".product-support__product-item");

    this.init();
  }

  init() {
    this.navItems.forEach((item) => {
      item.addEventListener("click", () => this.switchTab(item));
    });

    this.productItems.forEach((item) => {
      item.addEventListener("click", () => this.selectProduct(item));
    });
  }

  switchTab(selectedItem) {
    const targetId = selectedItem.dataset.target;

    // Update nav items
    this.navItems.forEach((item) => {
      item.classList.toggle("is-active", item === selectedItem);
      item.classList.toggle("border-primary", item === selectedItem);
      item.classList.toggle("text-primary", item === selectedItem);
    });

    // Update tab panels
    this.tabPanels.forEach((panel) => {
      panel.classList.toggle("hidden", panel.id !== targetId);
    });

    // Ensure product selection in the new tab
    const activePanel = this.querySelector(`#${targetId}`);
    if (activePanel) {
      let selectedProduct = activePanel.querySelector(
        ".product-support__product-item.is-selected"
      );

      // If no product is selected, select the first one
      if (!selectedProduct) {
        selectedProduct = activePanel.querySelector(
          ".product-support__product-item"
        );
      }

      // Always call selectProduct to ensure content is in sync
      if (selectedProduct) {
        this.selectProduct(selectedProduct);
      }
    }
  }

  selectProduct(selectedProduct) {
    const productId = String(selectedProduct.dataset.productId);
    const parentPanel = selectedProduct.closest(".product-support__tab-panel");

    if (!parentPanel || !productId) return;

    // Update product selection in the current panel
    parentPanel
      .querySelectorAll(".product-support__product-item")
      .forEach((item) => {
        const isSelected = item === selectedProduct;
        item.classList.toggle("is-selected", isSelected);
        const imgContainer = item.querySelector(
          ".product-support__product-image"
        );
        if (imgContainer) {
          imgContainer.classList.toggle("ring-2", isSelected);
          imgContainer.classList.toggle("ring-primary", isSelected);
        }
      });

    // Update all content sections visibility
    const contentContainer = parentPanel.querySelector(
      ".product-support__content-container"
    );
    if (contentContainer) {
      contentContainer
        .querySelectorAll(".product-support__product-content")
        .forEach((content) => {
          const contentProductId = String(content.dataset.contentFor);
          const shouldShow = contentProductId === productId;
          content.classList.toggle("hidden", !shouldShow);
        });
    }
  }
}

if (!customElements.get("product-support-tabs")) {
  customElements.define("product-support-tabs", ProductSupportTabs);
}
